// extracted by mini-css-extract-plugin
export default {"newzContainer":"news_newzContainer__f28fA"};